export const getRowConfig = (t, data = {}) => [
  {
    label: t('Identified Victims'),
    render: () => <span>{data.identifiedVictims || 0}</span>,
  },
  {
    label: t('Assisted Victims'),
    render: () => <span>{data.assistedVictims || 0}</span>,
  },
  {
    label: t('Monitored Locations'),
    render: () => <span>{data.locations || 0}</span>,
  },
  {
    label: t('Active Partners'),
    render: () => <span>{data.partners || 0}</span>,
  },
  {
    label: t('Testimonials'),
    render: () => <span>{data.testimonials || 0}</span>,
  },
]
